import { useEffect, useState } from 'react';
import {
    LambdaOperation,
    LambdaOperationMetadata,
    lambdaOperationsApi,
} from '@api/lambdaOperationsApi';
import { ApiError } from '@api/RestClient';
import { isErrorResponse } from '@utils/utils';
import { normalizeLambdaMetadata } from '../lambdaOperations.utils';

export const useLambdaOperationMetadata = (operation: LambdaOperation | null, presetId?: string) => {
    const [metadata, setMetadata] = useState<LambdaOperationMetadata | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<ApiError | null>(null);

    useEffect(() => {
        setMetadata(null);
        setError(null);

        if (!operation) {
            return;
        }

        const abortController = new AbortController();

        void (async () => {
            setLoading(true);
            const resp = await lambdaOperationsApi.getOperationMetadata(
                operation,
                abortController.signal,
                presetId
            );

            if (isErrorResponse(resp)) {
                setError(resp);
                setMetadata(null);
            } else {
                setError(null);
                setMetadata(normalizeLambdaMetadata(resp));
            }

            setLoading(false);
        })();

        return () => abortController.abort();
    }, [operation, presetId]);

    return { metadata, loading, error };
};
